import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Etiler Koltuk Yıkama", path: "/besiktas/etiler-koltuk-yikama" },
  { label: "Etiler Yorgan Yıkama", path: "/besiktas/etiler-yorgan-yikama" },
  { label: "Levent Koltuk Yıkama", path: "/besiktas/levent-koltuk-yikama" },
  { label: "Levent Perde Yıkama", path: "/besiktas/levent-perde-yikama" },
  { label: "Ortaköy Koltuk Yıkama", path: "/besiktas/ortakoy-koltuk-yikama" },
  { label: "Ortaköy Battaniye Yıkama", path: "/besiktas/ortakoy-battaniye-yikama" },
  { label: "Akatlar Koltuk Yıkama", path: "/besiktas/akatlar-koltuk-yikama" },
  { label: "Akatlar Kuru Temizleme", path: "/besiktas/akatlar-kuru-temizleme" },
  { label: "Bebek Koltuk Yıkama", path: "/besiktas/bebek-koltuk-yikama" },
  { label: "Bebek Yerinde Yıkama", path: "/besiktas/bebek-yerinde-yikama" },
  { label: "Beşiktaş Merkez Koltuk Yıkama", path: "/besiktas/merkez-koltuk-yikama" }
];

const BesiktasServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          BEŞİKTAŞ HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default BesiktasServiceArea;
